export const ProductInventoryTabs = {
  allProducts: 'ALL_PRODUCTS',
  lowInventory: 'LOW_INVENTORY',
  outofStock: 'OUT_OF_STOCK'
}